// Custom DTF Transfer by Sheet Size — print-as-is on 13" wide sheet
// Reads config from window.CDT_CONFIG (set by sections/custom-dtf-transfer.liquid)
(function () {
  const CFG = window.CDT_CONFIG || {};
  const SHEET_W = CFG.sheetWidth || 13;
  const SIZES = CFG.sizes && CFG.sizes.length ? CFG.sizes : (function () {
    const arr = [];
    for (let h = 10; h <= 300; h += 10) arr.push({ in: h, price: +(h * 0.42).toFixed(2) });
    return arr;
  })();
  const DEFAULT_H = 30;
  const ADDON_PROOF = CFG.addonProof != null ? CFG.addonProof : 5.00;
  const ADDON_RUSH  = CFG.addonRush  != null ? CFG.addonRush  : 8.00;

  let uploadedFile = null;
  let uploadedDataURL = null;
  let uploadedRemoteURL = null;
  let product = null;

  const $ = id => document.getElementById(id);
  const sheet = $('cdtSheet');
  if (!sheet) return;

  async function loadProduct() {
    if (!CFG.productHandle) return;
    try {
      const res = await fetch(`/products/${CFG.productHandle}.js`);
      if (res.ok) product = await res.json();
    } catch (e) { console.warn('Product load failed:', e); }
  }

  function findVariantByHeight(h) {
    if (!product) return null;
    const target = String(h);
    const matchNum = (s) => {
      const nums = String(s).match(/\d+(?:\.\d+)?/g) || [];
      return nums.includes(target);
    };
    const v = product.variants.find(v => {
      if (matchNum(v.title)) return true;
      return (v.options || []).some(o => matchNum(o));
    });
    if (!v) console.warn('[custom-dtf] no variant for height', h, '— variants seen:', product.variants.map(x => x.title));
    return v || null;
  }

  function populateHeights() {
    const sel = $('cdtHeight');
    sel.innerHTML = SIZES.map((s, i) =>
      `<option value="${i}"${s.in === DEFAULT_H ? ' selected' : ''}>${SHEET_W}" × ${s.in}" — $${(+s.price).toFixed(2)}</option>`
    ).join('');
    sel.addEventListener('change', () => { updatePrice(); updatePreview(); });
  }

  // ── UPLOAD (design captured locally; sent to R2 at Add to Cart) ─
  const fileInput = $('cdtFileInput');
  const uploadZone = $('cdtUploadZone');
  uploadZone.addEventListener('dragover', e => { e.preventDefault(); uploadZone.classList.add('dragover'); });
  uploadZone.addEventListener('dragleave', () => uploadZone.classList.remove('dragover'));
  uploadZone.addEventListener('drop', e => {
    e.preventDefault(); uploadZone.classList.remove('dragover');
    if (e.dataTransfer.files[0]) handleFile(e.dataTransfer.files[0]);
  });
  fileInput.addEventListener('change', e => { if (e.target.files[0]) handleFile(e.target.files[0]); });

  async function handleFile(f) {
    if (!f.type.startsWith('image/') && f.type !== 'application/pdf') {
      alert('Please upload an image or PDF.'); return;
    }
    if (f.size > 200 * 1024 * 1024) { alert('Max 200 MB.'); return; }
    uploadedFile = f;
    uploadedRemoteURL = null;

    const reader = new FileReader();
    reader.onload = ev => {
      uploadedDataURL = ev.target.result;
      if (f.type.startsWith('image/') && f.type !== 'image/svg+xml') {
        const img = new Image();
        img.onload = () => {
          const wIn = img.naturalWidth / 300;
          const hIn = img.naturalHeight / 300;
          $('cdtThumbImg').src = uploadedDataURL;
          $('cdtFileName').textContent = f.name;
          const overWidth = wIn > SHEET_W + 0.05;
          // Effective DPI if the file were printed at the FULL sheet width (13").
          // If they print smaller, DPI goes up, so this is the worst case.
          const worstDpi = img.naturalWidth / SHEET_W;
          let dpiBanner = '';
          if (worstDpi < 110) {
            dpiBanner = `<div class="cdt-dpi cdt-dpi-bad">⛔ Very low resolution (${Math.round(worstDpi)} DPI at 13" wide). This file will look pixelated if printed near the sheet width. Aim for at least 2600×N pixels.</div>`;
          } else if (worstDpi < 175) {
            dpiBanner = `<div class="cdt-dpi cdt-dpi-low">⚠ Low resolution (${Math.round(worstDpi)} DPI at 13" wide). Fine for small prints, may look soft at full sheet width.</div>`;
          } else if (worstDpi < 250) {
            dpiBanner = `<div class="cdt-dpi cdt-dpi-soft">Acceptable resolution (${Math.round(worstDpi)} DPI at 13" wide). Print quality is good; 300+ DPI is ideal.</div>`;
          } else {
            dpiBanner = `<div class="cdt-dpi cdt-dpi-good">✓ Print quality (${Math.round(worstDpi)} DPI at 13" wide)</div>`;
          }
          $('cdtFileDims').innerHTML =
            `${img.naturalWidth} × ${img.naturalHeight}px  ·  ` +
            `<strong style="color:var(--accent2)">${wIn.toFixed(2)}" × ${hIn.toFixed(2)}"</strong> @ 300 DPI` +
            (overWidth ? `<div style="color:#ff8080;margin-top:0.3rem;">⚠ Image is wider than ${SHEET_W}" — art beyond ${SHEET_W}" will be cropped by our roll.</div>` : '') +
            dpiBanner;
          $('cdtFileSize').innerHTML = `<span>${fmtBytes(f.size)}</span>`;
          $('cdtFileInfo').classList.add('visible');
          updatePreview();
        };
        img.src = uploadedDataURL;
      } else {
        $('cdtThumbImg').removeAttribute('src');
        $('cdtFileName').textContent = f.name;
        $('cdtFileDims').textContent = f.type === 'application/pdf' ? 'PDF — printed as-is' : 'SVG (vector) — printed as-is';
        $('cdtFileSize').innerHTML = `<span>${fmtBytes(f.size)}</span>`;
        $('cdtFileInfo').classList.add('visible');
        updatePreview();
      }
    };
    reader.readAsDataURL(f);
    // Upload is deferred to Add to Cart — no network calls while the customer shops.
  }

  const UPLOAD_WORKER_URL = 'https://txdtf-upload.txdtfprinting.workers.dev/sign-upload';

  async function uploadToR2(file) {
    const progEl = $('cdtUploadProgress');
    const progFill = $('cdtUploadProgressFill');
    const progText = $('cdtUploadProgressText');
    progEl.classList.add('visible');
    progText.textContent = 'Requesting upload URL…';
    progFill.style.width = '0%';

    const signRes = await fetch(UPLOAD_WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        filename: file.name,
        contentType: file.type || 'application/octet-stream',
        size: file.size
      })
    });
    if (!signRes.ok) {
      const err = await signRes.json().catch(() => ({ error: signRes.statusText }));
      progText.textContent = `⚠ ${err.error || 'Failed to prepare upload'}`;
      throw new Error(err.error || 'Failed to prepare upload');
    }
    const { uploadUrl, publicUrl } = await signRes.json();

    progText.textContent = 'Uploading design…';

    await new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', uploadUrl);
      xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
      xhr.upload.onprogress = e => {
        if (e.lengthComputable) {
          const pct = (e.loaded / e.total) * 100;
          progFill.style.width = pct.toFixed(0) + '%';
          progText.textContent = `Uploading design… ${pct.toFixed(0)}%`;
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          progFill.style.width = '100%';
          progText.textContent = '✓ Uploaded';
          resolve();
        } else {
          progText.textContent = `⚠ Upload failed (${xhr.status})`;
          reject(new Error(`Upload failed: ${xhr.status}`));
        }
      };
      xhr.onerror = () => {
        progText.textContent = '⚠ Network error during upload';
        reject(new Error('Network error'));
      };
      xhr.send(file);
    });

    uploadedRemoteURL = publicUrl;
    setTimeout(() => progEl.classList.remove('visible'), 1500);
    return publicUrl;
  }

  window.cdtClearFile = function () {
    uploadedFile = null; uploadedDataURL = null; uploadedRemoteURL = null;
    fileInput.value = '';
    $('cdtFileInfo').classList.remove('visible');
    $('cdtUploadProgress').classList.remove('visible');
    updatePreview();
  };

  function fmtBytes(b) {
    if (b < 1024) return b + ' B';
    if (b < 1048576) return (b/1024).toFixed(1) + ' KB';
    return (b/1048576).toFixed(2) + ' MB';
  }

  function currentSize() {
    const idx = parseInt($('cdtHeight').value || 0);
    return SIZES[idx] || SIZES[0];
  }

  function updatePreview() {
    const sel = currentSize();
    const heightIn = sel.in;

    sheet.style.setProperty('--sheet-w', SHEET_W);
    sheet.style.setProperty('--sheet-h', heightIn);

    const overlay = $('cdtDesignOverlay');
    if (uploadedDataURL) {
      overlay.innerHTML = `<img src="${uploadedDataURL}" alt="">`;
    } else {
      overlay.innerHTML = `<div class="placeholder">UPLOAD YOUR<br/><span>PRINT-READY FILE</span></div>`;
    }

    const label = `${SHEET_W}" × ${heightIn}"`;
    $('cdtSizeBadge').textContent = label;
    if ($('cdtSheetWLabel')) $('cdtSheetWLabel').textContent = `${SHEET_W}"`;
    if ($('cdtSheetHLabel')) $('cdtSheetHLabel').textContent = `${heightIn}"`;
    $('cdtPfSize').textContent = label;
  }

  window.addEventListener('resize', updatePreview);

  window.cdtChangeQty = function (d) {
    const el = $('cdtQty');
    el.value = Math.max(1, parseInt(el.value || 1) + d);
    updatePrice();
  };

  function updatePrice() {
    const sel = currentSize();
    const qty = Math.max(1, parseInt($('cdtQty').value || 1));
    const proof = $('cdtAddonProof').checked;
    const rush = $('cdtAddonRush').checked;

    let unitPrice = +sel.price;
    if (product) {
      const v = findVariantByHeight(sel.in);
      if (v) unitPrice = v.price / 100;
    }

    const transferCost = unitPrice * qty;
    const proofCost = proof ? ADDON_PROOF : 0;
    const rushCost = rush ? ADDON_RUSH : 0;
    const total = transferCost + proofCost + rushCost;

    const label = `${SHEET_W}" × ${sel.in}"`;
    $('cdtPriceDisplay').textContent = unitPrice.toFixed(2);
    $('cdtPricePer').textContent = `per sheet · ${label}`;
    $('cdtSumSize').textContent = label;
    $('cdtSumTransfer').textContent = `$${transferCost.toFixed(2)}`;
    $('cdtSumQty').textContent = qty;
    $('cdtSumProofRow').style.display = proof ? 'flex' : 'none';
    $('cdtSumRushRow').style.display = rush ? 'flex' : 'none';
    $('cdtSumTotal').textContent = total.toFixed(2);
  }
  window.cdtUpdatePrice = updatePrice;

  function stashPreview(dataURL) {
    if (!dataURL || !dataURL.startsWith('data:')) return null;
    try {
      const id = 'p_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 7);
      const store = JSON.parse(localStorage.getItem('txdtf_previews') || '{}');
      store[id] = dataURL;
      const ids = Object.keys(store);
      if (ids.length > 30) {
        const trimmed = {};
        ids.slice(-30).forEach(k => { trimmed[k] = store[k]; });
        localStorage.setItem('txdtf_previews', JSON.stringify(trimmed));
      } else {
        localStorage.setItem('txdtf_previews', JSON.stringify(store));
      }
      return id;
    } catch (e) { console.warn('preview stash failed', e); return null; }
  }

  window.cdtAddToCart = async function () {
    if (!uploadedFile) {
      alert('Please upload your print-ready file before adding to cart.');
      const zone = $('cdtUploadZone');
      if (zone) { zone.scrollIntoView({ behavior: 'smooth', block: 'center' }); zone.classList.add('needs-attention'); setTimeout(() => zone.classList.remove('needs-attention'), 2000); }
      return;
    }
    const sel = currentSize();
    const qty = parseInt($('cdtQty').value || 1);
    const notes = $('cdtNotes')?.value || '';
    const proof = $('cdtAddonProof').checked;
    const rush = $('cdtAddonRush').checked;

    let variantId = null;
    if (product) {
      const v = findVariantByHeight(sel.in);
      if (v) variantId = v.id;
    }
    if (!variantId) {
      alert(`No variant found for ${SHEET_W}" × ${sel.in}". Make sure the Custom DTF product has a variant option whose title/value contains "${sel.in}".`);
      return;
    }

    const btn = $('cdtAddToCartBtn');
    if (btn) { btn.disabled = true; btn.textContent = 'Uploading design…'; }

    if (!uploadedRemoteURL) {
      try {
        await uploadToR2(uploadedFile);
      } catch (e) {
        alert('Upload failed: ' + e.message + '\n\nPlease try again or contact support.');
        if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
        return;
      }
    }

    const addOns = [];
    if (proof) addOns.push('Digital Proof');
    if (rush) addOns.push('Rush Production');

    const previewId = stashPreview(uploadedDataURL);
    const label = `${SHEET_W}" × ${sel.in}"`;

    const properties = {
      'Sheet Size': label,
      'Print Mode': 'As-Is (customer-supplied file)',
      ...(uploadedRemoteURL ? { 'Design URL': uploadedRemoteURL } : {}),
      ...(previewId ? { 'Preview ID': previewId } : {}),
      ...(uploadedFile ? { 'Filename': uploadedFile.name } : {}),
      ...(addOns.length ? { 'Add-Ons': addOns.join(', ') } : {}),
      ...(notes ? { 'Notes': notes } : {})
    };

    if (btn) btn.textContent = 'Adding to cart…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties }] })
      });
      const json = await res.json();
      if (!res.ok) {
        alert('Could not add to cart: ' + (json.description || json.message || res.statusText));
        if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
        return;
      }
      window.location.href = '/cart';
    } catch (e) {
      alert('Network error: ' + e.message);
      if (btn) { btn.disabled = false; btn.textContent = '🎉 Add to Cart'; }
    }
  };

  (async function init() {
    populateHeights();
    await loadProduct();
    updatePrice();
    updatePreview();
  })();
})();
